export const theme = {
  spArtistImgAspect: 2 / 3,
  pcArtistImgAspect: 3 / 4,
  spPlaceImgAspect: 3 / 4,
  pcPlaceImgAspect: 2 / 3,
};
